// extracted by mini-css-extract-plugin
export default {"queue_details":"leaveApproval_queue_details__oX9Wi","queue_details_loading":"leaveApproval_queue_details_loading__0Srf6","queue_loading":"leaveApproval_queue_loading__JKLVy"};